import {
  styled,
  ToucanSettingsPart,
  ToucanSettingsSection,
  useEditedText,
} from "toucan";
import { store } from "../state.ts";

const Fields = styled("div")`
  display: grid;
  gap: 0.375rem;

  label,
  input,
  .muted {
    margin: 0;
  }

  /* The weight a field's label carries inside a form; these name a field from
     a section of their own. */
  label {
    font-weight: 600;
  }
`;

/**
 * Write the link, dropping it where it has been emptied. The store is a proxy
 * whose `deleteProperty` trap refuses a key it does not hold, so a key that was
 * never set is left alone.
 */
function saveWhatsapp(link: string): void {
  const me = store().me;
  if (link !== "") {
    me.whatsapp = link;
  } else if (me.whatsapp !== undefined) {
    delete me.whatsapp;
  }
}

/** As `saveWhatsapp`, repeated because the lint rule refuses a computed key. */
function saveLinkedin(link: string): void {
  const me = store().me;
  if (link !== "") {
    me.linkedin = link;
  } else if (me.linkedin !== undefined) {
    delete me.linkedin;
  }
}

/**
 * People's own section of Settings: your share-back links. Add one once, and
 * the capture form then offers a code the person you have just met can scan to
 * reach you.
 *
 * Each link is written when its field is left, so there is nothing to press.
 */
export function QrSettings() {
  const whatsapp = useEditedText(store().me.whatsapp, (text) => {
    saveWhatsapp(text.trim());
  });
  const linkedin = useEditedText(store().me.linkedin, (text) => {
    saveLinkedin(text.trim());
  });
  return (
    <ToucanSettingsSection heading="Your QR codes">
      <ToucanSettingsPart stack>
        <p>
          The code on the add-a-person form, for someone you’ve just met to scan
          and reach you.
        </p>
      </ToucanSettingsPart>
      <ToucanSettingsPart stack>
        <Fields>
          <label>
            WhatsApp link or number
            <input
              type="text"
              placeholder="https://wa.me/qr/… or +44…"
              value={whatsapp.text}
              onInput={whatsapp.onInput}
              onChange={whatsapp.onDone}
            />
          </label>
          <p class="muted">
            In WhatsApp: Settings → QR icon → Share, then paste the wa.me link
            here.
          </p>
        </Fields>
      </ToucanSettingsPart>
      <ToucanSettingsPart stack>
        <Fields>
          <label>
            LinkedIn profile
            <input
              type="text"
              placeholder="linkedin.com/in/… or just the handle"
              value={linkedin.text}
              onInput={linkedin.onInput}
              onChange={linkedin.onDone}
            />
          </label>
        </Fields>
      </ToucanSettingsPart>
    </ToucanSettingsSection>
  );
}
